import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    standalone: false
})
export class DashboardCardComponent implements OnInit {
  @Input() cardParams: any;

  constructor() { }

  ngOnInit() {
  }

}
